import { Component, Inject, OnDestroy } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { takeWhile } from "rxjs/operators";
import { AggregatorService } from "src/app/services/aggregator/aggregator.service";

@Component({
    selector: 'aggregator-delete-modal',
    template: `
                <button mat-icon-button class="close-button" [mat-dialog-close]="true">
                  <mat-icon class="close-icon" color="warn">close</mat-icon>
              </button>
              <h5 mat-dialog-title class="text-danger">Confirmation</h5>
                <div mat-dialog-content >
                    <div class="col-md-12 mt-3">
                        <h6>Are you sure to Reject this Aggregator <b class="text-success">{{data.agentName}}</b></h6>
                    </div>
                    <form [formGroup]="confirmation">
                        <div class="col-md-12 mt-3">
                            <div class="form-group">
                                <label>Type <b class="text-danger">Reject</b> to delete Aggregator</label>
                                <input type="text" class="form-control" formControlName="InputValue">
                            </div>
                        </div>
                    </form>
                </div>
                <div mat-dialog-actions align="end" > 
                    <button class="btn btn-sm btn-danger mr-2" (click)="onCancel()">No</button>
                    <button class="btn btn-sm btn-success" cdkFocusInitial (click)="rejectAggregator()" [disabled]="confirmation.invalid">Yes</button>
                </div>`,
    styles: ['label { font-size:14px; }']
})

export class AggregatorRejectModal implements OnDestroy {
    isAlive: boolean = true
    confirmation: UntypedFormGroup;
    constructor(
        public dialogRef: MatDialogRef<AggregatorRejectModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private httpService: AggregatorService,
        private fb: UntypedFormBuilder) {
        this.confirmation = fb.group({
            "InputValue": ['', [Validators.required]]
        }, { validator: this.ConfirmingRemark },)
    }

    ConfirmingRemark(c: AbstractControl): { invalid: boolean } {
        if (c.get('InputValue').value !== 'Reject') {
            return { invalid: true };
        }
    }

    rejectAggregator() {
        var obj = {
            'idAggregatorData': this.data.idAggregatorData
        }
        this.httpService.rejectAggregator(obj).pipe(takeWhile(() => this.isAlive)).subscribe(
            res => {
                this.dialogRef.close('rejected');
            }, err => {
                console.log('error', err)
            })
    }

    onCancel() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.isAlive = false
    }
}